export default __webpack_public_path__ + "static/media/metamask.7db94670.svg";